// PlayShop — Countdown précommande + AUTO-OUVERTURE au drop
// Cherche les éléments [data-ps-preorder-countdown] avec un timestamp Unix (secondes) et tick chaque seconde.
// Format affiché :
//   > 24h restantes → "X JOURS" ou "1 JOUR"
//   ≤ 24h          → "HH:MM:SS"
//   ≤ 0            → "Ouverture…" PENDANT que la page sonde la vraie dispo du produit.
//
// v4 (2026-10-13, meme soiree) : LES PAGES DE LISTE AUSSI. La v3 ne rattrapait que les pages
// produit, seules a porter le marqueur data-ps-avail. Lorenzo : « faudrait un refresh auto des
// pages la ou les minuteurs se terminent, sur les produits, les pages etc, pour que tout le monde
// soit synchro ». Or les vignettes portent DEJA data-ps-product-available : le marqueur anti-boucle
// existait par carte, il suffisait de le lire. Aucune modification du theme n'a ete necessaire.
// Sur une collection ou l'accueil, on retient les cartes que le serveur declare indisponibles ET
// dont un minuteur vient d'expirer, on en sonde au plus TROIS (les plus recemment ouvertes), et on
// recharge des que l'une devient achetable. ⛔ Le plafond et le jitter ne sont pas du confort :
// 1 900 personnes attendent ce drop, et sonder trente produits par personne ferait le travail
// d'une attaque.
//
// v3 (2026-10-13) : LE TROU DE LA v2. handleOpening() ne partait que si un minuteur tombait a 0
// SOUS LES YEUX du client (_psCounting). Celui qui ARRIVE apres l'heure (il clique le lien Discord
// a 17h00:20, ou tape l'URL) a un minuteur deja expire au chargement : aucune sonde, aucun
// rechargement, et il voit « EPUISE » servi par le cache. C'est lui qui devait faire F5 a la main,
// et c'est le cas le plus frequent le jour d'un drop. Lorenzo, apres le 23/09 : « ca arrivait
// petit a petit sur 17h01 17h02, faut vraiment que les gens refresh ».
// Desormais on sonde AUSSI dans ce cas, sous trois gardes strictes :
//   1. la page porte data-ps-avail="false" (ce que le SERVEUR a rendu) : si elle dit deja
//      « disponible », il n'y a rien a rafraichir, donc aucune sonde et aucune boucle possible ;
//   2. l'expiration est RECENTE (< 20 min) : on ne sonde pas un drop vieux de trois jours ;
//   3. au plus 3 rechargements par onglet (sessionStorage), ceinture absolue contre la boucle
//      si le CDN s'obstine a servir du HTML perime.
// Le rechargement porte un parametre unique (?_ps=<ts>) : meme URL = meme cache CDN, URL
// differente = HTML frais. Le parametre est retire de la barre d'adresse juste apres.
//
// v2 (2026-08-12) : plus de F5 manuel au drop. Le stock est armé par un cron avec un léger
// décalage après l'heure d'ouverture → entre le minuteur à 0 et l'armement, la page affichait
// "ÉPUISÉ / SOLD OUT". Désormais, quand un minuteur tombe à 0 SOUS LES YEUX du client, on
// sonde /products/{handle}.js (JSON léger, servi par le CDN Shopify) toutes les ~5 s avec un
// jitter aléatoire (anti-stampede), et on recharge la page DÈS que le produit est achetable.
(function () {
  'use strict';
  function pad(n) { return String(n).padStart(2, '0'); }
  function nowSec() { return Math.floor(Date.now() / 1000); }
  function format(targetSec) {
    var rem = targetSec - nowSec();
    if (rem <= 0) return 'OUVERT';
    if (rem > 86400) {
      var d = Math.floor(rem / 86400);
      return d + (d > 1 ? ' JOURS' : ' JOUR');
    }
    var h = Math.floor(rem / 3600);
    var m = Math.floor((rem % 3600) / 60);
    var s = rem % 60;
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  // Handle produit à sonder : page produit sinon la carte dont le minuteur a expiré.
  function findHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
    var els = document.querySelectorAll('[data-ps-preorder-countdown]');
    for (var i = 0; i < els.length; i++) {
      var t = parseInt(els[i].getAttribute('data-ps-preorder-countdown'), 10);
      if (t && (t - nowSec()) <= 0) {
        var card = els[i].closest('.ps-card') || els[i].closest('article') || els[i].parentElement;
        var a = card ? card.querySelector('a[href*="/products/"]') : null;
        if (a) { var mm = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (mm) return mm[1]; }
      }
    }
    return null;
  }

  // Rechargement qui CONTOURNE le cache CDN (meme URL = meme cache), avec une ceinture : au-dela
  // de 3 fois dans l'onglet on s'arrete, quoi qu'il arrive. Mieux vaut une page perimee qu'une
  // page qui se recharge en boucle sous les doigts du client.
  var RELOADS_MAX = 3;
  function rechargerFrais() {
    var n = 0;
    try { n = parseInt(sessionStorage.getItem('psDropReloads') || '0', 10) || 0; } catch (e) {}
    if (n >= RELOADS_MAX) return;
    try { sessionStorage.setItem('psDropReloads', String(n + 1)); } catch (e) {}
    var u = new URL(location.href);
    u.searchParams.set('_ps', String(Date.now()));
    location.replace(u.toString());
  }

  var opening = false;
  function handleOpening() {
    if (opening) return;
    opening = true;
    var handle = findHandle();
    // Sans handle identifiable : simple rechargement différé (léger jitter).
    if (!handle) { setTimeout(rechargerFrais, 3000 + Math.random() * 3000); return; }
    var tries = 0;
    function poll() {
      tries++;
      fetch('/products/' + handle + '.js?_ts=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.available) { rechargerFrais(); return; } // stock armé → on bascule sur l'état live
          if (tries < 60) setTimeout(poll, 4000 + Math.random() * 2500); // ~5 min max, jitter anti-rafale
        })
        .catch(function () { if (tries < 60) setTimeout(poll, 5000 + Math.random() * 2500); });
    }
    // Petit délai initial : laisse le cron d'armement écrire le stock avant la 1re sonde.
    setTimeout(poll, 1500 + Math.random() * 2000);
  }

  function tickAll() {
    var freshExpiry = false;
    document.querySelectorAll('[data-ps-preorder-countdown]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-ps-preorder-countdown'), 10);
      if (!target) return;
      var rem = target - nowSec();
      if (rem > 0) {
        el._psCounting = true; // était en train de compter
        el.textContent = format(target);
      } else {
        // On ne déclenche l'auto-ouverture QUE si le minuteur comptait encore au tick précédent
        // (= il vient de tomber à 0 pendant que le client regarde). Un minuteur déjà expiré au
        // chargement ne déclenche rien : le serveur a déjà rendu l'état ouvert.
        if (el._psCounting) { freshExpiry = true; el._psCounting = false; }
        el.textContent = 'OUVERT';
      }
    });
    // v4 : sur une page de liste, c'est surveillerListe qui sait quoi sonder (plusieurs cartes,
    // plafonnees) ; sur une fiche, handleOpening suffit (un seul handle, celui de l'URL).
    if (freshExpiry) { if (document.querySelector('[data-ps-avail]')) handleOpening(); else surveillerListe(); }
  }

  var FENETRE_SEC = 1200;   // 20 min : au-dela, ce n'est plus un drop en cours
  var MAX_SONDES = 3;       // on ne sonde jamais toute la page

  // Les cartes d'une page de liste qui MERITENT une sonde : le serveur les declare
  // indisponibles et un de leurs minuteurs vient d'expirer. Si le serveur dit deja
  // « disponible », la carte n'est pas candidate : c'est la garde anti-boucle, par produit.
  function candidatsListe() {
    var out = [];
    document.querySelectorAll('[data-ps-product-available]').forEach(function (carte) {
      if (carte.getAttribute('data-ps-product-available') !== 'false') return;
      var depuisMin = null;
      carte.querySelectorAll('[data-ps-preorder-countdown]').forEach(function (el) {
        var t = parseInt(el.getAttribute('data-ps-preorder-countdown'), 10);
        if (!t) return;
        var depuis = nowSec() - t;
        if (depuis >= 0 && depuis <= FENETRE_SEC && (depuisMin === null || depuis < depuisMin)) depuisMin = depuis;
      });
      if (depuisMin === null) return;
      var a = carte.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) out.push({ handle: m[1], depuis: depuisMin });
    });
    out.sort(function (a, b) { return a.depuis - b.depuis; });  // le plus fraichement ouvert d'abord
    return out.slice(0, MAX_SONDES);
  }

  var surveille = false;
  function surveillerListe() {
    if (surveille) return;
    var cibles = candidatsListe();
    if (!cibles.length) return;
    surveille = true;
    var tours = 0;
    function tour() {
      tours++;
      Promise.all(cibles.map(function (c) {
        return fetch('/products/' + c.handle + '.js?_ts=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return !!(p && p.available); })
          .catch(function () { return false; });
      })).then(function (dispos) {
        if (dispos.indexOf(true) !== -1) { rechargerFrais(); return; }
        if (tours < 60) setTimeout(tour, 4000 + Math.random() * 3000);
      });
    }
    setTimeout(tour, 1500 + Math.random() * 2500);
  }

  // ⛔ v3 : le client qui ARRIVE apres l'heure. Trois gardes (voir l'entete) avant de sonder.
  function rattraperArriveeTardive() {
    var racine = document.querySelector('[data-ps-avail]');
    // v4 : pas de fiche produit => page de LISTE (collection, accueil, recherche). Les vignettes
    // portent leur propre marqueur, donc la garde anti-boucle vaut carte par carte.
    if (!racine) { surveillerListe(); return; }
    if (racine.getAttribute('data-ps-avail') !== 'false') return;  // le serveur dit deja « dispo »
    var plusRecente = null;
    document.querySelectorAll('[data-ps-preorder-countdown]').forEach(function (el) {
      var t = parseInt(el.getAttribute('data-ps-preorder-countdown'), 10);
      if (!t) return;
      var depuis = nowSec() - t;
      if (depuis >= 0 && (plusRecente === null || depuis < plusRecente)) plusRecente = depuis;
    });
    if (plusRecente === null) return;                     // aucun minuteur expire
    if (plusRecente > 1200) return;                       // expire depuis plus de 20 min : pas un drop en cours
    handleOpening();
  }

  function init() { tickAll(); setInterval(tickAll, 1000); rattraperArriveeTardive(); }
  // Le cache-buster a fait son office : on le retire de la barre d'adresse (sans recharger).
  try {
    if (new URL(location.href).searchParams.has('_ps') && history.replaceState) {
      var propre = new URL(location.href);
      propre.searchParams.delete('_ps');
      history.replaceState(null, '', propre.pathname + (propre.search || '') + propre.hash);
    }
  } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
